import { render, staticRenderFns } from "./TradingTime.vue?vue&type=template&id=b56eeeee&scoped=true&"
import script from "./TradingTime.vue?vue&type=script&lang=js&"
export * from "./TradingTime.vue?vue&type=script&lang=js&"
import style0 from "./TradingTime.vue?vue&type=style&index=0&id=b56eeeee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b56eeeee",
  null
  
)

export default component.exports